import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/components/base.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { BottomSheetComponent } from '../bottom-sheet/bottom-sheet.component';
import { MaskService } from 'src/app/shared/services/mask.service';

@Component({
  selector: 'app-detalhe-projeto-layout',
  templateUrl: './detalhe-projeto-layout.component.html',
  styleUrls: ['./detalhe-projeto-layout.component.scss']
})
export class DetalheProjetoLayoutComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {

  id: number;
  permissions: ProjetoPermission;
  menu: any[];
  pathRoute: string;
  infoProjeto: any;
  menuActive: boolean;

  @ViewChild('menuDesktop') menuDesktop: ElementRef;
  @ViewChild('menuMobile') menuMobile: ElementRef;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private storage: StorageService,
    private pesquisaGeralService: PesquisaGeralService,
    private navigation: NavigationService,
    private maskService: MaskService,
    private _bottomSheet: MatBottomSheet,
  ) {
    super()
  }

  ngOnInit(): void {
    this.initLayout();
    this.addSub(EventSharedService.get('reloadLayout').subscribe(() => {
      this.initLayout();
    }));
    this.addSub(EventSharedService.get('reloadId').subscribe(() => {
      this.storage.setIdProjeto(this.id);
    }));
  }

  ngAfterViewInit(): void {
    this.verificarOverflow();
  }

  ngOnDestroy(): void {
    this.storage.removeIdProjeto();
    this.unsubscribeList();
  }

  initLayout() {
    this.id = this.activatedRoute.snapshot.params?.idProjeto;
    this.infoProjeto = this.activatedRoute.snapshot.data['infoProjeto'];
    this.permissions = this.activatedRoute.snapshot.data['permissions'];
    this.pesquisaGeralService.setInfoProject(this.infoProjeto);
    this.storage.setIdProjeto(this.id);
    this.storage.setProjeto(this.infoProjeto);
    this.initMenu();
    this.pesquisaGeralService.info.subscribe((info) => {
      this.infoProjeto = info;
      this.initMenu();
    });
  }

  initMenu(path = null) {
    this.pathRoute = path ? path : "/projetos/projeto/" + this.id + "/";
    this.menu = [
      this.infoProjeto.menu['cadastro'],
      this.infoProjeto.menu['indicadores'],
      this.infoProjeto.menu['entregas'],
      this.infoProjeto.menu['analises'],
      this.infoProjeto.menu['pontos-criticos'],
      this.infoProjeto.menu['irfe'],
      this.infoProjeto.menu['ircp'],
      this.infoProjeto.menu['demandas'],
      this.infoProjeto.menu['execucao-orcamentaria'],
      this.infoProjeto.menu['proa'],
      this.infoProjeto.menu['obras'],
      this.infoProjeto.menu['sgo'],
      this.infoProjeto.menu['documentos'],
      this.infoProjeto.menu['produto'],
      this.infoProjeto.menu['cronograma'],
    ];
  }

  isActive(route: string): boolean {
    return this.router.routerState.snapshot.url.includes(route);
  }

  onActivate(component) {
    component.idProjeto = this.id;
    component.permissions = this.permissions;
    component.infoProjeto = this.infoProjeto;
  }

  openBottomSheet(): void {
    this._bottomSheet.open(BottomSheetComponent, { data: { pathRoute: this.pathRoute, menu: this.menu, type: 'projeto' } });
  }

  verificarOverflow(): void {
    const menuDesktop = this.menuDesktop.nativeElement;
    const menuMobile = this.menuMobile.nativeElement;
    if (menuDesktop.offsetHeight > 70) {
      menuDesktop.classList.add('menu-desktop-none');
      menuMobile.classList.add('menu-mobile-active');
    } else {
      menuMobile.classList.remove('menu-mobile-active');
      menuDesktop.classList.remove('menu-desktop-none');
    }
  }

  get maskProjeto():string|number{
    return this.maskService.maskProjetoId(this.infoProjeto.code) ?? this.infoProjeto.code;
  }
}
